import styled from "styled-components";
import { theme } from "../../../config";

export const BodyWrapper = styled.div`
  margin-top: 20px;
`;

export const ModalButtonsWrapper = styled.div`
  float: right;
  & #cancel_btn {
    background: ${theme.colors.neutral.black6};
    border: 1px solid ${theme.colors.neutral.black6};
    margin-right: 21px;
  }
`;
